import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    overflow: hidden;
  }

  button {
    font-family: inherit;
  }
`;
